import { Component, OnInit } from '@angular/core';
import { ActivatedRoute,  Router } from '@angular/router';
import { BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import { AlertsService } from 'app/ui-components/alerts/alerts.service';
import { ProductService } from 'app/services/product.service';
import { ProductDetails, ProductDtls, ProductImage } from 'app/models/products.model';
import { MockProdDetails } from 'app/models/data/mock/products';
import { PageConfig } from 'config/page.config';
import { SharedDataService } from 'app/services/sharedData.service';
import { Subscription, UserSubscription } from 'app/models/customer.model';
import { UserService } from 'app/users/user.service';

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss']
})

export class ProductDetailComponent implements OnInit {

  qtyList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  selectedQty = 1;
  prodDetails: any = {};
  imgPath: string = '';
  productId!: string;
  isPhonePortrait: boolean = false;
  isTablet: boolean = false;
  subscriptions: UserSubscription[] = [];
  isUserWithSub: boolean = false;
  customerNumber!: string;

  constructor(
    private router: Router,
    private prodService: ProductService,
    private alertService: AlertsService,
    private aRoute: ActivatedRoute,
    private sharedDataService: SharedDataService,
    private responsive: BreakpointObserver,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.responsive.observe([
      Breakpoints.TabletPortrait,
      Breakpoints.TabletLandscape,
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait])
      .subscribe(result => {
        const breakpoints = result.breakpoints;
        this.isPhonePortrait = false;
        this.isTablet = false;
        if (breakpoints[Breakpoints.TabletPortrait] || breakpoints[Breakpoints.TabletLandscape]) {
          this.isTablet = true;
        } else if (breakpoints[Breakpoints.HandsetPortrait]) {
          this.isPhonePortrait = true;
        } else if (breakpoints[Breakpoints.HandsetLandscape]) {
          this.isTablet = true;
        }
      }
    );
    let pdId;
    this.aRoute.parent!.paramMap.subscribe(params => {
      pdId = params.get('id')
    });
    this.customerNumber = this.userService.profile?.customerNumber ?? '';
    if(pdId) {
      this.productId = pdId;
      this.retrieveDetails(this.productId);
    } else {
      this.alertService.displayError("Error occured while retrieving product");
    }
    sessionStorage.setItem('products', '[{}]');

    if(this.isUserWithSub) {
      sessionStorage.removeItem('products');
    }

  }

  retrieveDetails(productId : string) {
    //fetch product image
    this.imgPath = ProductImage[productId];
    Object.assign(this.prodDetails, MockProdDetails);
    this.retrieveSubIfExists();
  }


  addToCart() {
    let products = sessionStorage.getItem("products");
    if (products !== null) {
      var prods: [{[key: string]: number}] = JSON.parse(products);
      var found: boolean = false; 
      for (var product of prods) {
        if (product[this.productId] !== null) {
          product[this.productId] = this.selectedQty;
          found = true;
        } 
      }
      if (!found) prods.push({[this.productId]: this.selectedQty});
      products = JSON.stringify(prods);
    } else {
      const prod: {[key: string]: number} = { [this.productId]: this.selectedQty};
      products = JSON.stringify([prod]);
    }
    sessionStorage.setItem("products", products);
    
    //new logic
    let cartProducts = sessionStorage.getItem('cartProducts');
    if (cartProducts != null && cartProducts != '[{}]') {
      var prodList: [{[key: string]: ProductDtls}] = JSON.parse(cartProducts);
      var found: boolean = false; 
      for (var item of prodList) {
        if (item[this.productId] !== null) {
          item[this.productId].quantity = this.selectedQty;
          found = true;
        } 
      }
      if (!found) { 
        var prodDtl: ProductDtls = {quantity: this.selectedQty, servicePeriodCode:''};
        prodList.push({[this.productId]: prodDtl});
      }
      cartProducts = JSON.stringify(prodList);
    } else {
      var prodDtl: ProductDtls = {quantity: this.selectedQty, servicePeriodCode:''};
      const prod: {[key: string]: ProductDtls} = { [this.productId]: prodDtl};
      cartProducts = JSON.stringify([prod]);
    }
    //sessionStorage.setItem("cartProducts", cartProducts);
    this.sharedDataService.setCartProducts(JSON.parse(cartProducts), false);
    this.sharedDataService.setQuantity(this.selectedQty);
    this.router.navigate([PageConfig.paths.ocm.billing]);
  
  }

  retrieveSubIfExists() {
    this.sharedDataService.getSubscriptions.subscribe(data => {
      if(data !== null) {
        const subscriptions = data.filter( (d) => d.Status.Name === "Active" && d.Components[0].ItemNumber === this.productId);
        if (subscriptions.length > 1) 
          this.router.navigate([PageConfig.paths.invalidPermissions, {error: 'Multiple active subscriptions.'}]);
        const sub = subscriptions[0];
        const users =  sub.Participants.filter( (p) => p.CustomerNumber === this.customerNumber && p.AccessType === "AccessOnly")
        this.isUserWithSub = users.length > 0;
        if(this.isUserWithSub) {
          let adminRec = sub.Participants.find((p) => p.AccessType.startsWith("Admin"));
          const subscription: UserSubscription = {
            productNumber: sub.Components[0].ItemNumber,
            expireDate: new Date(sub.AgreementExpires).toLocaleDateString(),
            adminName: adminRec?.FullName ? adminRec?.FullName : '',
            adminEmail: adminRec?.Email ? adminRec?.Email : ''
          }
          this.subscriptions.push(subscription);  
        }
      }
    });
  }
}
